import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectAvailableMoneySources, selectPlacingMoneySource } from '../../../../selectors/publishTerms';
import { setPlacingMoneySource } from '../../../../actions/publishTerms';
import { loadPublishTerms } from '../../../../thunks/publishTerms/loadPublishTerms';

import { getOptions } from './utils';
import { MoneySource } from './MoneySource';
import { EMoneySource } from '../../../../types/reducers/user';

export const MoneySourceContainer = () => {
  const dispatch = useDispatch();
  const moneySource = useSelector(selectPlacingMoneySource);
  const availableMoneySources = useSelector(selectAvailableMoneySources);
  const options = getOptions(availableMoneySources);

  const handleChange = React.useCallback(
    (value: EMoneySource) => {
      dispatch(setPlacingMoneySource(value));
      dispatch(loadPublishTerms());
    },
    [dispatch],
  );

  return <MoneySource value={moneySource || ''} options={options} handleChange={handleChange} />;
};
